import { FC } from 'react';
import { CommonModal } from '../CommonModal';
import subscriptionListClass from '../../assets/scss/SubscriptionList/SubscriptionList.module.scss';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';
import { BottomButton } from '../ModalItem/BottomButton';

type PayBackPointsRateModalProps = {
  active: boolean;
  closeFunc: () => void;
  payBackPointsRateModal: PayBackPointsRateModalViewType | null;
};

export type PayBackPointsRateModalViewType = {
  title: string;
  text: string;
  progressWidth: string;
};

export const PayBackPointsRateModal: FC<PayBackPointsRateModalProps> = ({
  active,
  closeFunc,
  payBackPointsRateModal,
}) => {
  if (!payBackPointsRateModal) return null;

  const content = (
    <>
      <div className={subscriptionListClass.pointsRateContainer}>
        <div
          className={subscriptionListClass.pointsRateTitle}
          dangerouslySetInnerHTML={{ __html: payBackPointsRateModal.title }}
        />
        <div
          className={subscriptionListClass.pointsRateText}
          dangerouslySetInnerHTML={{ __html: payBackPointsRateModal.text }}
        />
        <div className={subscriptionListClass.progressContainer}>
          <div
            className={subscriptionListClass.progressMarker}
            style={{ left: payBackPointsRateModal.progressWidth }}
          />
          <div className={subscriptionListClass.progressBackground}>
            <div
              className={subscriptionListClass.progressBar}
              style={{ width: payBackPointsRateModal.progressWidth }}
            />
          </div>
          <div className={subscriptionListClass.progressLabels}>
            <div className={subscriptionListClass.label2}>2%</div>
            <div className={subscriptionListClass.label3}>3%</div>
            <div className={subscriptionListClass.label4}>4%</div>
            <div className={subscriptionListClass.label5}>5%</div>
          </div>
        </div>
      </div>
      <div
        className={commonModalClass.btnContainer}
        style={{ marginBottom: '12px' }}
      >
        <BottomButton
          buttonTitle="閉じる"
          clickFunc={closeFunc}
        />
      </div>
    </>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={closeFunc}
    >
      {content}
    </CommonModal>
  );
};
